import {createContext} from 'react';

const DialogBaseContext = createContext();
export default DialogBaseContext;



